import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';

@Component({
  selector: 'app-common-subproducts-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  imports: [CommonModule, ToHtmlPipe, UrlParamsPipe],
  encapsulation: ViewEncapsulation.None,
})
export class CommonSubProductsPricingComponent implements OnInit {
  @Input() pricingData: any;
  @Input() customClass: any;
  @Input() isInside: any;
  queryParams: any;
  constructor(
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
  _pricingData: any;
  ngOnInit(): void {
    this._pricingData = this.pricingData;
  }
  ngOnChanges(): void {
    this._pricingData = this.pricingData;
  }
}
